var lastGenericErrorToastShownAt = new Date(0)

function showGenericErrorMessageToast ()
{
    const duration = 8000
    if (new Date() - lastGenericErrorToastShownAt < duration) return
    lastGenericErrorToastShownAt = new Date()
    
    const errorText = 'Oups une erreur s\'est glissée dans le code, nous travaillons dessus !'

    window.app.$toast.error(errorText, { position: 'top', duration })
}

const apiErrorMessages = 
{
    0: data => 'Ce courriel est déjà attribué',
    1: data => 'Ce pseudonyme est déjà attribué',
    2: data => `Plusieurs comptes sont liés à ce courriel : ${data.join(', ')}. Vous devez utiliser un de ces identifiants pour continuer.`
}

const conflictGenericMessage = 'Cette action est impossible car il y a un conflit avec les données déjà existantes'

export default { showGenericErrorMessageToast, apiErrorMessages, conflictGenericMessage }


// WEBPACK FOOTER //
// ./src/utils/errorUtils.js